import { render } from "./index.vue?vue&type=template&id=8f3b5c42&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=8f3b5c42&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f3b5c42"]])

export default __exports__